import * as React from 'react';
import Typography  from '@mui/material/Typography';

const Title = (props: any) => {
    const {small, ...rest} = props;
    const variant = small ? "h5" : "h3";
    return <Typography variant={variant} component="h1" gutterBottom {...rest} />
}

export default Title;